/*
 * @Author: Ryan
 * @Date: 2026-02-04
 * @Description: CTA section for Face Swap SEO page
 */
import React from 'react';

import StartButton from './StartButton';

const CTASection: React.FC = () => {
  return (
    <section className="w-full bg-[#0A0A0A] py-[80px] pad:py-[100px] sm:py-[120px] px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto text-center">
        <h2 className="text-2xl pad:text-3xl sm:text-[42px] font-bold text-white mb-4 pad:mb-6 leading-tight">
          Create Stunning Face Swap Videos Today
        </h2>

        <p className="text-sm pad:text-base sm:text-base text-gray-400 max-w-4xl mx-auto mb-8 pad:mb-10 sm:mb-12 leading-relaxed">
          Turn your ideas into reality with FalcoCut&apos;s AI-powered face swap. Upload,
          swap, and share in minutes. From hilarious memes to jaw-dropping
          transformations, FalcoCut makes every swap fun and lifelike.
        </p>

        <StartButton text="Swap Your Face" />
      </div>
    </section>
  );
};

export default CTASection;
